var path = '/app/components/loadingCover/loadingcover.html';
var html = "<div class=\"action-waiting ng-fade\" ng-if=ctrl.loader.isVisible ng-class=\"{ 'position-fixed': ctrl.loader.position_fixed, 'bg-none': ctrl.loader.options.no_background }\" ng-animate> <div class=circle-loader ng-class=\"{ 'load-complete': ctrl.loader.complete }\" ng-style=\"{ 'border-left-color': ctrl.loader.options.ring_primary_color }\"> <div class=\"checkmark draw\" ng-if=ctrl.loader.complete></div> </div> <p class=lead ng-if=ctrl.loader.message>{{ ctrl.loader.message }}</p> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/loadingCover/loadingcover.html
// module id = 990
// module chunks = 0